/*
 * Copyright (c) Dito Technologies LLC
 */

import {graphql} from "babel-plugin-relay/macro";
import {
    BarFinderUserConfirmationMutation$data,
    BarFinderUserConfirmationMutation$variables
} from "./__generated__/BarFinderUserConfirmationMutation.graphql";
import perform from "mutation/perform";

const mutation = graphql`
    mutation BarFinderUserConfirmationMutation($input: MusicParseStepBarFinderUserConfirmationInput!) {
        music_parse_step_bar_finder_user_confirmation(input: $input) {
            parse_step {
                id
                status
            }
        }
    }
`;

export default function BarFinderUserConfirmation(parseStepId: string, pageId: string, deletedBarStorageNames: string[]): Promise<BarFinderUserConfirmationMutation$data> {
    const variables: BarFinderUserConfirmationMutation$variables = {
        input: {
            parse_step_id: parseStepId,
            page_id: pageId,
            deleted_bar_storage_names: deletedBarStorageNames
        }
    };
    return perform(mutation, variables);
}
